import { useEffect } from 'react'
import { getQueryParam } from '../utils/getQueryParam'
import { useStorageState } from '../utils/useStorageState'
import { OAuth } from './oauth'

export function useOAuthFlow() {
  const code = getQueryParam('code')
  const redirect = getQueryParam('redirect')
  const [token, setToken] = useStorageState<string | undefined>('token')

  if (!token && !code) {
    OAuth.authorize() // will throw suspense
  }

  useEffect(() => {
    if (code) {
      OAuth.exchangeCodeForToken(code)
        .then((accessToken) => {
          setToken(accessToken)
        })
        .catch(() => {
          OAuth.authorize()
        })
        .then(() => {
          // todo: replace with remembered last url before auth redirect
          window.history.replaceState({}, document.title, window.location.pathname)
        })
    }
    if (token && redirect) {
      // User already has a token and there's a redirect - redirect immediately
      // Token validation is handled by OAuth.initiateToken() below
      window.location.replace(redirect)
    }
  }, [code, redirect, token])

  useEffect(() => {
    OAuth.initiateToken(token)
  }, [token])

  return token
}
